import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ContainerWithoutInner } from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import Button from '@/components/objects/button';
import { trackInquiryClick } from '@/components/foundations/openaiTracking';
import * as styles from './keyVisual.module.scss';
import * as containerStyles from '@/components/foundations/content/content.module.scss';
import * as Buttonstyles from '@/components/objects/button/button.module.scss';
import LogoSvg from '@/svgs/common/logo';

const KeyVisualContent: React.FC<{ modal: Function; isScrolled: boolean }> = ({ modal, isScrolled }) => {
  const [pleaseScroll, setPleaseScroll] = useState(false);
  const [vh, setVh] = useState(0);

  const innnerStyle = classNames(containerStyles.lContent__inner, styles.lContent__inner);
  const outerStyle = classNames(styles.oKeyVisual__outer, {
    [styles.pleaseScroll]: pleaseScroll && isScrolled,
  });
  const computedInnerStyle = {
    height: vh < 1 ? '100vh' : `${vh}px`,
  };

  useEffect(() => {
    setVh(window.innerHeight);
    setTimeout(() => {
      if (!isScrolled) setPleaseScroll(true);
    }, 6000);
  }, []);

  return (
    <div className={outerStyle}>
      <div className={innnerStyle} style={computedInnerStyle}>
        <div className={styles.oKeyVisual__message}>
          <p>
            <span>Webサービスやシステムを<br />改善したい方へ</span>
            <br />
            <span>UIの専門家による<br />スピーディーな改善提案</span>
          </p>
          <h1 hidden>PIVOTのUIエキスパートレビュー</h1>
          <h2>
            <LogoSvg />
            <strong>UIエキスパートレビュー</strong>
          </h2>
          <p>
            UIエキスパートレビューとは？
            <br />
            <small>
              ユーザビリティに関する専門家が
              <br />
              サービスやプロダクトの使いやすさを向上させるための
              <br />
              改善策を提案します。
            </small>
          </p>
          <a href="https://pivot.jp/contact" onClick={trackInquiryClick}>
            <Button
              className={`${styles.oButton, Buttonstyles.conversion}`}
            >
              相談してみる
            </Button>
          </a>
        </div>
      </div>
      <figure className={styles.oKeyVisual__image}>
        <StaticImage src="./img/kv_ui.png" alt="" />
      </figure>
    </div>
  );
};

const KeyVisual: React.FC<{ modal: Function; isScrolled: boolean }> = ({ modal, isScrolled }) => {
  return (
    <ContainerWithoutInner className={{ wrapper: styles.oKeyVisual }} intersection={{ visible: styles.visible }}>
      <KeyVisualContent modal={modal} isScrolled={isScrolled} />
    </ContainerWithoutInner>
  );
};

export default KeyVisual;
